// src/components/ShareableArticle/ShareableArticle.tsx
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { mainSliceActions } from '../../store/mainSlice';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './styles';
import { ArticleShareData } from 'src/utils/encrypt';
import { useFetchHtmlForShare } from 'src/hooks/useFetchHtmlForShare';
import { injectArticleCss } from 'src/utils/injectArticleCss';

interface ShareableArticleProps {
  articleData: ArticleShareData;
  isHeader: boolean;
}

const ShareableArticle: React.FC<ShareableArticleProps> = ({ articleData, isHeader }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const {
    htmlContent,
    isLoadingHtml,
    isHtmlError,
    noDataHtmlMsg,
  } = useAppSelector((state) => state.main);

  useFetchHtmlForShare(articleData.articleId);

  useEffect(() => {
    dispatch(mainSliceActions.setCurrentId(articleData.articleId));
    dispatch(mainSliceActions.setIsModal(true));
  }, [articleData.articleId, dispatch]);

  useEffect(() => {
    injectArticleCss();
  }, []);

  return (
    <styles.Container>
      <styles.ScrollViewWrapper>
        <styles.ScrollView>
          {isLoadingHtml ? (
            <styles.LoadingContainer>
              <CircularProgress style={{ width: '55px', height: '55px' }} />
            </styles.LoadingContainer>
          ) : noDataHtmlMsg ? (
            <div>{t("noSearchData")}</div>
          ) : isHtmlError ? (
            <div>{t("errorMsg")}</div>
          ) : (
            <styles.ContentWrapper>
              <styles.Header>
                {articleData && isHeader && (
                  <styles.HeaderContainer>
                    <styles.HeaderTitle variant="h4">{t('versionDetails')}</styles.HeaderTitle>
                    <styles.SubHeader>
                      <styles.System variant="subtitle1">
                        <styles.SystemImage src={`./${articleData.mainClassificationName}.png`} alt='' />
                        <styles.SystemText>
                          {articleData.mainClassificationName}
                        </styles.SystemText>
                      </styles.System>
                      <styles.VerticalLine />
                      <styles.Date variant="subtitle1">
                        <styles.DateText>
                          {articleData.relevantFromDate && articleData.relevantFromDate.split('-').reverse().join('.')}
                        </styles.DateText>
                      </styles.Date>
                      <styles.VerticalLine />
                      <styles.Version variant="subtitle1">
                        <styles.VersionText>
                          {t('ArticleHeader')} {articleData.articleHeader}
                        </styles.VersionText>
                      </styles.Version>
                    </styles.SubHeader>
                  </styles.HeaderContainer>
                )}
              </styles.Header>
              <styles.Article 
                className='shareable-article-html'
                dangerouslySetInnerHTML={{ __html: htmlContent }} />
            </styles.ContentWrapper>
          )}
        </styles.ScrollView>
      </styles.ScrollViewWrapper>
      {/* <styles.BottomGap /> */}
    </styles.Container>
  );
};

export default ShareableArticle;